<template>
  <span v-for="{ file_name, file_path, _id } in files" :key="_id" class="link">
    <a class="cursor-pointer" @click="viewFile({ file_path })">
      {{ file_name }}
    </a>
    <span v-if="_id !== files[files.length - 1]._id">
      {{ ", " }}
    </span>
  </span>
</template>

<script setup>
defineProps({
  files: {
    type: Array,
    required: true,
  },
});

const { viewFile } = useFile();
</script>

<style scoped>
.link {
  word-break: break-all;
}
</style>
